import React from 'react';
import PropTypes from 'prop-types';
import { applySpec, path, pathOr } from 'ramda';
import InformationTable from './InformationTable.jsx';
import { useContactRoleLabel } from './useContactRoleLabel.js';

const extractContactData = applySpec({
  firstName: pathOr('', ['firstName']),
  lastName: pathOr('', ['lastName']),
  role: pathOr('', ['role']),
  phones: pathOr([], ['phones']),
  emails: pathOr([], ['emails'])
});

export const ContactSummary = ({ contact, getMiddleText }) => {
  const { firstName, lastName, role, phones, emails } = extractContactData(contact);

  const getRoleLabel = useContactRoleLabel(getMiddleText);

  const roleLabel = getRoleLabel(role);

  return (
    <div className="flex flex-col p-4">
      <InformationTable
        items={[
          {
            label: getMiddleText('ENTREPRISE_CONTACT_DECIDEUR_PRENOM_LABEL', 'Prénom'),
            value: firstName
          },
          {
            label: getMiddleText('ENTREPRISE_CONTACT_DECIDEUR_NOM_LABEL', 'Nom'),
            value: lastName
          },
          { label: 'Rôle', value: roleLabel },
          ...phones.map((phone) => ({
            label: getMiddleText('ENTREPRISE_CONTACT_DECIDEUR_TELEPHONE_LABEL', 'Téléphone'),
            value: `${path(['internationalCode'], phone)} ${path(['number'], phone)}`
          })),
          ...emails.map((email) => ({
            label: getMiddleText('ENTREPRISE_CONTACT_DECIDEUR_EMAIL_LABEL', 'Email'),
            value: email.value
          }))
        ]}
      />
    </div>
  );
};

ContactSummary.propTypes = {
  contact: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    role: PropTypes.string,
    phones: PropTypes.arrayOf(
      PropTypes.shape({
        internationalCode: PropTypes.string,
        number: PropTypes.string,
        isMobile: PropTypes.bool
      })
    ),
    emails: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string
      })
    )
  }).isRequired,
  getMiddleText: PropTypes.func.isRequired
};
